import { useEffect, useState } from 'react';
import { getProcessEnvUrl } from 'utils/getUrl';
import NotFound from '../NotFound/NotFound';

export default function Login() {
  const [isError, setErrorFlag] = useState(false);

  useEffect(() => {
    const dashboardUrl = getProcessEnvUrl('DASHBOARD_URL');
    if (dashboardUrl) window.location.assign(dashboardUrl);
    else setErrorFlag(true);
  }, []);

  return isError ? <NotFound /> : null;
}
